import { axiosGet } from "../../../../../../packages/apiPackage/axiosRequest";
import ApiConstants from "../../../../../../utils/apiConstants";

async function fetchSectionThirteen({ setOrganizer, dispatch }) {
  try {
    var response = await axiosGet({
      endpoint: ApiConstants.GET_ORGANIZER,
    });
    const data = response.data;
    dispatch(setOrganizer(data));

    return;
  } catch (error) {
    console.log("error = ", error);
    if (!error?.response) {
      console.log("No server response.");;
    } else if (error.response?.status === 404) {
      console.log("Page Not Found");
    } else if (
      error.response?.status === 400 ||
      error.response?.status === 401
    ) {
      console.log("User Credit Expired!!!\nPlease Login Again.");
    } else {
      console.log("Internal Server Error.");
    }
    return;
  }
}

export default fetchSectionThirteen;
